import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core';

const styles = {
    root: {
        border: '1px solid',
        borderRadius: '100px',
        color: '#0088CF',
        backgroundColor: 'transparent',
        width: '60px',
        height: '20px',
        minHeight: '10px !important',
        marginLeft: '0px',
        marginRight:'10px',
        padding: '0px',
        fontSize: '0.675rem',
        '&:hover':{
            backgroundColor:'#0072ff2e !important'
        }
    },
    // outlined: {
    //     color: '#0088CF',
    //     backgroundColor: 'transparent',
    // }
}

const CustomButton = withStyles(styles)(Button);
export default CustomButton;